import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value || '';
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const isValidLength = password.length >= 8;
    const uniqueChars = new Set(password).size;

    const errors: ValidationErrors = {};

    if (!hasUppercase) errors['uppercase'] = true;
    if (!hasLowercase) errors['lowercase'] = true;
    if (!hasDigit) errors['digit'] = true;
    if (!hasSpecialChar) errors['specialChar'] = true;
    if (!isValidLength) errors['length'] = true;
    if (uniqueChars < 3) errors['uniqueChars'] = true;

    return Object.keys(errors).length ? errors : null;
  };
}
